import React, {useEffect, useState} from "react";
import {Button, Col, Divider, Form, Input, message, Radio, Row, Space, Spin} from "antd";
import {step_8_inactive_img} from '../../../AppImageConst';
import {CustomerWrapperDto} from "../../dto/CustomerWrapperDto";
import {SecondApplicantDetailDto} from "../../dto/SecondApplicantDetailDto";
import Validation from "../../util/Validation";
import {
    COMMON_DROPDOWN,
    EMAIL_MAX_LENGTH,
    EMAIL_VALIDATION,
    IDENTIFICATION_SOURCE,
    MOBILE_NUMBER_MAX_LENGTH,
    MOBILE_NUMBER_MIN_LENGTH,
    NIC_VALIDATION,
    PARAMETER_LIST
} from "../../util/Constants";
import {
    MSG_FAILED_TO_FETCH_IDENTIFICATION_SOURCE_TYPES_ERROR,
    MSG_PLEASE_ENTER_A_VALID_EMAIL
} from "../../util/Messages";
import customerService from "../../service/customerService";
import {CustomerDto} from "../../dto/CustomerDto";
import ErrorHandler from "../../util/ErrorHandler";
import {DropdownListDto} from "../../dto/DropdownListDto";
import {InputDropdownParameterDto} from "../../dto/InputDropdownParameterDto";
import signupService from "../../service/signupService";
import {toLower} from "lodash";


interface SecondApplicantDetailProps {
    savedCusDetailFromPreviousStep: CustomerWrapperDto
    getStepperFilledData: (data: CustomerWrapperDto) => void,
    switchStep?: () => void,
    isFromSummaryView: boolean
}

const SecondApplicantDetail = (props: SecondApplicantDetailProps) => {
    const [form] = Form.useForm();
    const [isCustomerExisting, setCustomerIsExisting] = useState(false);
    const [isCustomerDataEnterd, setCustomerDataEntered] = useState(false);
    const [isSpinnerLoading, setSpinnerLoading] = useState(false);

    const [dropdownDto, setDropdownDto] = useState<DropdownListDto | undefined>({label: "NIC", value: 1});
    const [identificationSourceTypeList, setIdentificationSourceTypeList] = useState<DropdownListDto[]>([]);
    const [exisitingCustomerData, setExistingCustomerData] = useState<CustomerWrapperDto>({});
    useEffect(() => {
        loadIdentitySourceTypes()
        setExistingCustomerData(props.savedCusDetailFromPreviousStep);
        if (props.savedCusDetailFromPreviousStep.customerMstDto.secondApplicantDetailDto) {
            setCustomerDataEntered(true)
            setFormValue(props.savedCusDetailFromPreviousStep.customerMstDto.secondApplicantDetailDto)
            setCustomerIsExisting(props.savedCusDetailFromPreviousStep.customerMstDto.secondApplicantDetailDto.isExistingCustomer)

            let dropdownListDto = identificationSourceTypeList.find((obj: DropdownListDto) => {
                return obj.value == props.savedCusDetailFromPreviousStep.customerMstDto.secondApplicantDetailDto.identificationSourceId
            });
            setDropdownDto(dropdownListDto)
        }
    }, [])

    const setFormValue = (secondApplicantDetailDto: SecondApplicantDetailDto) => {
        form.setFieldsValue(
            {
                isExistingCustomer: secondApplicantDetailDto.isExistingCustomer,
                name: secondApplicantDetailDto.name,
                mobileNumber: secondApplicantDetailDto.mobileNumber,
                email: secondApplicantDetailDto.email,
                cidNumber: secondApplicantDetailDto.cidNumber,
                identificationSourceId: secondApplicantDetailDto.identificationSourceId,
                identificationSourceValue: secondApplicantDetailDto.identificationSourceValue
            }
        )
    }
    const submitStep = (value: SecondApplicantDetailDto) => {
        let customerWrapperDto = exisitingCustomerData
        if (props.savedCusDetailFromPreviousStep.customerMstDto.secondApplicantDetailDto) {
            if (validateFieldChanges(exisitingCustomerData.customerMstDto.secondApplicantDetailDto, value)) {
                value.id = exisitingCustomerData.customerMstDto.secondApplicantDetailDto.id
                customerWrapperDto.customerMstDto.secondApplicantDetailDto = value
                customerWrapperDto.currentActiveStep = customerWrapperDto.completedStep
                customerWrapperDto.recordStatus = "UPDATE"
                props.getStepperFilledData(customerWrapperDto)
            } else {
                if (props.switchStep) props.switchStep()
            }

        } else {
            customerWrapperDto.customerMstDto.secondApplicantDetailDto = value
            customerWrapperDto.isFinalStep = true
            customerWrapperDto.recordStatus = "SAVE"
            props.getStepperFilledData(customerWrapperDto)
        }


    }
    const validateFieldChanges = (secondApplicantDetailDto: SecondApplicantDetailDto, fieldValues: SecondApplicantDetailDto) => {

        if (secondApplicantDetailDto.name != fieldValues.name) {
            return true;
        } else if (secondApplicantDetailDto.email != fieldValues.email) {
            return true;
        } else if (secondApplicantDetailDto.isExistingCustomer != fieldValues.isExistingCustomer) {
            return true;
        } else if (secondApplicantDetailDto.mobileNumber != fieldValues.mobileNumber) {
            return true;
        } else if (secondApplicantDetailDto.cidNumber != fieldValues.cidNumber) {
            return true;
        } else if (secondApplicantDetailDto.identificationSourceId != fieldValues.identificationSourceId) {
            return true;
        } else if (secondApplicantDetailDto.identificationSourceValue != fieldValues.identificationSourceValue) {
            return true;
        }

    }

    const onchangeIsExistingCustomer = (e: Event) => {
        setCustomerIsExisting(+(e.target as HTMLInputElement).value > 0)
        resetFields()
        //reset dropdown back to nic
        setDropdownDto({label: "NIC", value: 1})
    };

    const handleCINEnter = (val: string) => {
        if (val.trim() !== "") {
            setSpinnerLoading(true)
            customerService.getCustomerDateByCin(val).then(res => {
                if (res.data.results.customerMstDto != null) {
                    const customerDto = res.data.results.customerMstDto as CustomerDto
                    form.setFieldsValue(
                        {
                            mobileNumber: customerDto.mobileNo,
                            email: customerDto.email,
                            name: customerDto.nameToAppearOnStatement,
                            identificationSourceId: customerDto.identificationSource?.id,
                            identificationSourceValue: customerDto.identificationValue

                        }
                    )
                    let dropdownListDto = identificationSourceTypeList.find((obj: DropdownListDto) => {
                        return obj.value == customerDto.identificationSource?.id
                    });
                    setDropdownDto(dropdownListDto)
                    setSpinnerLoading(false)

                }

            }, (reason) => {
                ErrorHandler.handleError(reason);
                resetFields()
                setSpinnerLoading(false)
            })
        }
    }
    const resetFields = () => {
        form.resetFields(["cidNumber", "mobileNumber", "email", "name", "identificationSourceId",
            "identificationSourceValue"])
    }
    const loadIdentitySourceTypes = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.IDENTIFICATION_SOURCE,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        signupService.getCommonDropdownList(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                setIdentificationSourceTypeList(res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_IDENTIFICATION_SOURCE_TYPES_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    const getPlaceHolderByIdentificationType = (identificationType: string | undefined) => {
        if (undefined != identificationType) {
            return IDENTIFICATION_SOURCE.NIC === identificationType ? identificationType : toLower(identificationType)
        }
        return "N/A"
    }
    const onChangeSourceType = (e: Event) => {
        form.setFieldsValue({identificationSourceValue: ''})

        let dropdownListDto = identificationSourceTypeList.find((obj: DropdownListDto) => {
            return obj.value == (e.target as HTMLInputElement).value
        });
        setDropdownDto(dropdownListDto)
    };
    return (
        <Spin spinning={isSpinnerLoading} tip="Loading" size="large">
            <div>
                <p className='step_card_header'>
                    <div className="icon-container">
                        <img className='header-icon-img' src={step_8_inactive_img}/>
                    </div>
                    Second Applicant Detail
                </p>
                <Form
                    className='form-input'
                    layout={"vertical"}
                    form={form}
                    disabled={props.isFromSummaryView}
                    onFinish={submitStep}
                >

                    <Row gutter={[32, 0]}>
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className='custom-yes-no-radio-btn'>
                            <Form.Item
                                label="Is the second applicant an existing customer?"
                                name={"isExistingCustomer"}
                                rules={!props.isFromSummaryView ?
                                    [{required: true, message: 'Please select whether the customer is existing'}] : []}>
                                <Radio.Group optionType="button"
                                             buttonStyle="solid"
                                             getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                                             onChange={onchangeIsExistingCustomer}
                                             disabled={isCustomerDataEnterd}
                                >

                                    <Radio.Button value={true}>Yes</Radio.Button>
                                    <Radio.Button value={false}>No</Radio.Button>

                                </Radio.Group>

                            </Form.Item>
                        </Col>
                        {
                            isCustomerExisting ?
                                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                                    <Form.Item
                                        label="CIN"
                                        name={"cidNumber"}
                                        onKeyPress={Validation.isNumberWithoutDot}
                                        rules={!props.isFromSummaryView ?
                                            [{required: true, message: 'Please enter CIN'}] : []}>
                                        <Input disabled={props.isFromSummaryView || isCustomerDataEnterd}
                                               onBlur={(e: any) => handleCINEnter(e.target.value)}
                                               placeholder={"Enter CIN"}/>
                                    </Form.Item>
                                </Col> : ''
                        }

                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                                label="Name"
                                name={"name"}
                                onKeyPress={Validation.onlyAlphabeticWithSpaceAndDot}
                                rules={!(isCustomerExisting || props.isFromSummaryView || isCustomerDataEnterd) ? [
                                    {required: true, message: 'Please enter name'},
                                    {whitespace: true, message: 'Cannot contain whitespaces'},
                                    {max: 30, message: 'The maximum length is 30 characters'},
                                ] : []}>
                                <Input disabled={isCustomerExisting || props.isFromSummaryView || isCustomerDataEnterd}
                                       placeholder={"Enter name"}/>
                            </Form.Item>
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <Form.Item
                                label="Email"
                                name={"email"}
                                rules={!(isCustomerExisting || props.isFromSummaryView || isCustomerDataEnterd) ? [
                                    {required: true, message: 'Please enter your email'},
                                    {max: EMAIL_MAX_LENGTH, message: 'The maximum length is 254 characters'},
                                    {
                                        pattern: EMAIL_VALIDATION,
                                        message: MSG_PLEASE_ENTER_A_VALID_EMAIL
                                    },

                                ] : []}>
                                <Input disabled={isCustomerExisting || props.isFromSummaryView || isCustomerDataEnterd}
                                       placeholder={"Enter name"}/>
                            </Form.Item>
                        </Col>
                        <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                            <Form.Item
                                label={"Mobile Number"}
                                name="mobileNumber"
                                onKeyPress={Validation.isNumberWithoutDot}
                                rules={!(isCustomerExisting || props.isFromSummaryView || isCustomerDataEnterd) ? [
                                    {required: true, message: 'Please enter your mobile number'},
                                    {
                                        validator: (_, value) => {
                                            const mobileNumberWithoutSpaces = value ? value.replace(/\s/g, '') : '';
                                            if (mobileNumberWithoutSpaces.length > MOBILE_NUMBER_MAX_LENGTH) {
                                                return Promise.reject('The maximum length is 15 numbers');
                                            } else if (mobileNumberWithoutSpaces.length < MOBILE_NUMBER_MIN_LENGTH) {
                                                return Promise.reject('Minimum of 7 characters are required');
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ] : []}>
                                <Input disabled={isCustomerExisting || props.isFromSummaryView || isCustomerDataEnterd}
                                       placeholder="Enter mobile number"/>
                            </Form.Item>

                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <Form.Item
                                label="Identification Source"
                                name={"identificationSourceId"}
                                initialValue={1}
                                rules={!(isCustomerExisting || props.isFromSummaryView || isCustomerDataEnterd) ? [
                                    {required: true, message: 'Please select identification source'},
                                ] : []}>

                                <Radio.Group onChange={onChangeSourceType}
                                             disabled={isCustomerExisting || props.isFromSummaryView || isCustomerDataEnterd}
                                             defaultValue={dropdownDto?.value}>
                                    {identificationSourceTypeList.map((data: DropdownListDto) => {
                                        return <Radio value={data.value}>{data.label}</Radio>
                                    })}
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                        <Col xl={12} lg={12} md={24} sm={24} xs={24}>
                            <Form.Item
                                label={dropdownDto?.label.concat(" Number")}
                                name="identificationSourceValue"
                                onKeyPress={(dropdownDto?.label === IDENTIFICATION_SOURCE.NIC) ? Validation.nicFieldValidation : Validation.isNumbersAndLetters}
                                rules={[
                                    {
                                        required: !(isCustomerExisting || props.isFromSummaryView || isCustomerDataEnterd),
                                        message: 'Please enter your '.concat(getPlaceHolderByIdentificationType(dropdownDto?.label)).concat(" number")
                                    },
                                    (dropdownDto?.label !== IDENTIFICATION_SOURCE.NIC) ? {
                                        max: 15,
                                        message: 'The maximum length is 15 characters'
                                    } : {},
                                    (dropdownDto?.label === IDENTIFICATION_SOURCE.NIC) ? {
                                        pattern: NIC_VALIDATION,
                                        message: "Please enter a valid NIC number"
                                    } : {},
                                ]}>
                                <Input disabled={isCustomerExisting || props.isFromSummaryView || isCustomerDataEnterd}
                                       placeholder={"Enter your ".concat(getPlaceHolderByIdentificationType(dropdownDto?.label)).concat(" number")}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    {
                        !props.isFromSummaryView ?
                            <>
                                <Row>
                                    <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Divider/>
                                    </Col>
                                </Row>
                                <Space style={{float: 'right'}} className='form_next_btn_col'>
                                    <Form.Item>
                                        <Button className='form_next_btn' htmlType="submit" type="primary">
                                            Next
                                        </Button>
                                    </Form.Item>
                                </Space>
                            </> : ''
                    }
                </Form>

            </div>
        </Spin>
    )

}
export default SecondApplicantDetail;

